export enum ServicesOptions {
  Fingerprint = 'Fingerprint',
  Bookkeeper = 'Bookkeeper',
  Sonar = 'Sonar',
}
